import { render, staticRenderFns } from "./FooterContact.vue?vue&type=template&id=e5c448ce&"
import script from "./FooterContact.vue?vue&type=script&lang=js&"
export * from "./FooterContact.vue?vue&type=script&lang=js&"
import style0 from "./FooterContact.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports